import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'

import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import withTranslation from '../../hocs/withTranslation'
import Dialog from '../../DialogWrapper'
import { IStore } from '../../../store/models'

const CreatedConversationDialog = (props) => {
  const { dialog, showDialog, changeLanguage, currentUser, conversation } = props
  const { step, skipProfileImage, hideShare } = dialog.data

  useEffect(() => {
    conversation && changeLanguage(conversation.locale)
  }, [conversation, changeLanguage])

  const afterClose = () => {
    if (!skipProfileImage && conversation && !currentUser.hasProfileImage) {
      showDialog('profileImage')
    }
  }

  if (!conversation) return null

  return (
    <Dialog dialog={dialog} name='createdConversation' afterClose={afterClose} type='noPadding' closeIcon={true}>
      {step === 1 ? <StepOne {...props} dialog={dialog} conversation={conversation} showDialog={showDialog} /> : null}
      {step === 2 ? <StepTwo {...props} dialog={dialog} conversation={conversation} /> : null}
      {step === 3 ? <StepThree {...props} dialog={dialog} conversation={conversation} hideShare={hideShare} /> : null}
    </Dialog>
  )
}

export default inject<FIXME, FIXME>(
  (
    {
      mst: {
        auth: { user },
        dialogs: { showDialog, closeDialog },
        conversations
      }
    }: {
      mst: IStore
    },
    ownProps
  ) => {
    const conversationId = ownProps.dialog.data.conversation.id
    const conversation = conversations.list.find((d) => d.id === conversationId)
    if (!conversation && !conversations.loadingIds.includes(conversationId)) {
      conversations.getConversation(conversationId)
    }
    return {
      currentUser: user,
      conversation,
      showDialog,
      closeDialog
    }
  }
)(observer(withTranslation(CreatedConversationDialog)))
